<template>
    <div class="container">
        <!-- <h4 class="pagetitle">
          カテゴリー
            <CreateplusMessage fcontId="0" flinkId="1" msgkey="2" />
        </h4> -->
        <template v-if="createplusCategoriesStatus">
            <create-plus-category-tiles :createplusCategories="initialDisplayedCategories"></create-plus-category-tiles>
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";
// import CreateplusMessage from "./CreateplusMessage";
import CreatePlusCategoryTiles from "./CreatePlusCategoryTiles";
export default {
  name: "CreatePlusCategory",
  components: {
    // CreateplusMessage,
    CreatePlusCategoryTiles
  },
  computed: {
    ...mapState('createplusTemplates', ['createplusCategories', 'createplusCategoriesStatus', 'createplusTemplates', 'createplusTemplatesStatus']),

    // 初期表示するカテゴリ
    initialDisplayedCategories: function() {
      let createplusCategories = this.createplusCategories;
      createplusCategories = Array.from(createplusCategories).sort((a, b) =>{
        if (a.categoryPriority === undefined || b.categoryPriority === undefined ){
          return 0
        }
        if (a.categoryPriority < b.categoryPriority) {
          return -1
        } else {
          return 1
        }
      })
      return createplusCategories;
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.fade-enter-active {
  transition: opacity 0.6s;
}
.fade-enter {
  opacity: 0;
}
</style>